import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { colors, ease, radius } from "../../theme";

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: ${(p) => (p.size === "sm" ? "10px 16px" : "14px 22px")};
  font-family: inherit;
  font-weight: 600;
  font-size: ${(p) => (p.size === "sm" ? "14px" : "15px")};
  border-radius: ${radius.pill};
  border: 1.5px solid transparent;
  text-decoration: none;
  cursor: pointer;
  transition: transform 200ms ${ease}, background 200ms ${ease}, color 200ms ${ease}, box-shadow 200ms ${ease}, border-color 200ms ${ease};
  white-space: nowrap;

  &:hover { transform: translateY(-1px); }
  &:active { transform: translateY(0); }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 4px rgba(0, 51, 204, 0.25);
  }
`;

const variants = {
  primary: css`
    background: ${colors.brand};
    color: white;
    box-shadow: 0 8px 24px -8px rgba(0, 51, 204, 0.55);
    &:hover { background: ${colors.brandDark}; }
  `,
  white: css`
    background: white;
    color: ${colors.brand};
    box-shadow: 0 8px 24px -10px rgba(255,255,255,0.5);
    &:hover { background: #f4f6ff; }
  `,
  outline: css`
    background: transparent;
    color: ${colors.ink};
    border-color: ${colors.line};
    &:hover { border-color: ${colors.brand}; color: ${colors.brand}; }
  `,
  outlineWhite: css`
    background: transparent;
    color: white;
    border-color: rgba(255,255,255,0.5);
    &:hover { background: rgba(255,255,255,0.1); border-color: white; }
  `,
  ghost: css`
    background: transparent;
    color: ${colors.brand};
    &:hover { background: ${colors.brandSoft}; }
  `,
  gold: css`
    background: ${colors.gold};
    color: ${colors.brandDeep};
    &:hover { background: #e9a72e; }
  `,
};

const styles = css`
  ${base}
  ${(p) => variants[p.variant || "primary"]}
`;

export const Button = styled.button`${styles}`;
export const LinkButton = styled(Link)`${styles}`;
export const ExternalButton = styled.a`${styles}`;
